import axios from 'axios'

export default {

    confirmation(id){
        return axios.get('/confirm/' + id)
            .then(response => {
                return response.data
            })
    },  
    setpassword(id,formdata){
        return axios.post('/set-password/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    forgotpassword(formdata){
        return axios.post('/forgot-password', formdata)
            .then(response => {
                return response.data
            })
    },
    activation(id){
        return axios.get('/account-activation/' + id)
            .then(response => {
                return response.data
            })
    }, 
}